type RawType = string | undefined | false | null;

function filter(array: Array<RawType>): Array<string> {
	return array.filter((item: RawType) => item) as Array<string>;
}

export function clsx(...args: Array<RawType>): string {
	return filter(Object.values(args)).reduce<string>((acc: string, item: string) => `${acc} ${item}`, '');
}
